
import {View} from 'backbone';
import template from 'dashboard/connections/details/action-vectordb.ejs';
import * as gridModels from 'dashboard/connections/action-type/ActionGridModels';
import util from 'util/Util';
import constants from 'Constants';
import sequenceService from 'SequenceService';
import RestService from 'RestService.js';
import { getLinkedApps } from '../../../../service/ai/api.js';

import _ from 'lodash';

class ActionVectorDB extends View {
    initialize(opts){

        this.template = template;
        this.actionService = opts.actionService;

        this.events = {
            "click button[name=addSend], button[name=addReturn]"          : "itemNew",
            "click button[name=removeSend], button[name=removeReturn]"    : "itemRemove",
            "click button[name=upSend], button[name=upReturn]"            : "itemUp",
            "click button[name=downSend], button[name=downReturn]"        : "itemDown"
        };
        this.onResize();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    itemNew(){
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);
        util.saveGridScrollPos(this.model, '.ui-jqgrid-bdiv');
        return this.actionService.itemNew.apply(this.actionService, arguments);
    }

    itemRemove(){
        util.saveGridScrollPos(this.model, '.ui-jqgrid-bdiv');
        return this.actionService.itemRemove.apply(this.actionService, arguments);
    }

    itemUp(){
        return this.actionService.itemUp.apply(this.actionService, arguments);
    }

    itemDown(){
        return this.actionService.itemDown.apply(this.actionService, arguments);
    }

    onResize(){
        $(window).bind('resize', () => { this.resizeGrid(); });
    }

    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    renderParametersGrid(colSendModel, colSendNames, colSendContainer, colReturnModel, colReturnNames, colReturnContainer){
        let currentModel = this.model.get('currentActionDetails'),
            self = this;

        let sendItemsToRender = currentModel.ActionXML.Action.Send.Parameter instanceof Array
            ? currentModel.ActionXML.Action.Send.Parameter
            : [currentModel.ActionXML.Action.Send.Parameter];

        let returnItemsToRender = currentModel.ActionXML.Action.Receive.Parameter instanceof Array
            ? currentModel.ActionXML.Action.Receive.Parameter
            : [currentModel.ActionXML.Action.Receive.Parameter];

        let gridSendObject = util.getGridObject(this, {
            colModel: colSendModel,
            colNames: colSendNames,
            autowidth: true,
            height: 300,
            scrollOffset: 0,
            ondblClickRow: this.ondblClickRowSend
        });
        let gridReturnObject = util.getGridObject(this, {
            colModel: colReturnModel,
            colNames: colReturnNames,
            autowidth: true,
            height: 300,
            scrollOffset: 0,
            ondblClickRow: this.ondblClickRowReceive
        });

        $(colSendContainer).jqGrid(gridSendObject);
        if (colReturnContainer) {
            $(colReturnContainer).jqGrid(gridReturnObject);
        }

        _.forEach(sendItemsToRender, (field, index) => {
            if (field && field._name) {
                self.fillNewRow(colSendContainer, index, field['_fixedValue'], field['_id'], field['_isFixed'],
                    field['_name'], field['_operation'], field['_value']);
            }
        });

        if (colReturnContainer) {
            _.forEach(returnItemsToRender, (field, index) => {
                if (field && field._name) {
                    self.fillNewRow(colReturnContainer, index, field['_fixedValue'], field['_id'], field['_isFixed'],
                        field['_name'], field['_operation'], field['_value']);
                }
            });
        }
    }

    ondblClickRowSend(rowid, iRow, iCol){
        let containerToWork = '#' + this.id;
        if (iCol === 5) {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: true});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: false});
        } else {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: false});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: true});
        }
        $(containerToWork).editCell(iRow, iCol, true);
    }

    ondblClickRowReceive(rowid, iRow, iCol){
        let containerToWork = '#' + this.id;
        if (iCol === 5) {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: true});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: false});
        } else {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: false});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: true});
        }
        $(containerToWork).editCell(iRow, iCol, true);
    }

    fillNewRow(grid, index, _fixedValue, _id, _isFixed, _name, _operation, _value) {
        $(grid).addRowData(index, {
            '_fixedValue': _fixedValue,
            '_id': _id,
            '_isFixed': _isFixed,
            '_name': _name,
            '_operation': _operation,
            '_value': _value
        });
    }

    setRow(rowId, e){
        $(`#${e.currentTarget.id}`).jqGrid('setSelection', rowId);
        this.model.set('currentGridSelector', `#${e.currentTarget.id}`, {silent: true});
    }

    onSelectRow(){}

    onCellSelect(){}

    onDoubleClickRow(){}

    onSelectAll(){}

    afterEditCell(rowId, cellName, value, iRow, iCol){
        let self = this;
        $("#" + iRow + "_" + cellName).bind('blur', function(){
            $(self.model.get('currentGridSelector')).saveCell(iRow, iCol);
        });
    }

    afterSaveCell(rowId, cellName, value, iRow, iCol){
        let currentGrid = this.model.get('currentGridSelector'),
            currentModel = this.model.get('currentActionDetails'),
            isSend = currentGrid.indexOf('Send') > 0;

        let parameterArray = isSend
            ? currentModel.ActionXML.Action.Send.Parameter
            : currentModel.ActionXML.Action.Receive.Parameter;

        if (!(parameterArray instanceof Array)) {
            parameterArray = [parameterArray];
        }

        if (parameterArray[rowId]) {
            parameterArray[rowId]['_' + cellName] = value;
        }

        this.model.set('currentActionDetails', currentModel, {silent: true});
        this.model.set('hasChanges', true);
    }

    render(){
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const currentActionDetails = this.model.get('currentActionDetails');
        if (currentActionDetails) {
            this.renderParametersGrid(
                gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                gridModels.GRID_VECTORDB_PARAMETER_HEADERS,
                constants.CONNECTION_SELECT_SEND_CONTAINER,
                gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                gridModels.GRID_VECTORDB_PARAMETER_HEADERS,
                constants.CONNECTION_SELECT_RETURN_CONTAINER
            );
        }

        this.resizeGrid();
        this.delegateEvents();

        // For UPSERT actions, auto-populate Send Parameters with fields from linked app
        if (currentActionDetails && currentActionDetails.Type === constants.CONNECTION_VECTORDB_UPSERT) {
            this.autoPopulateUpsertFields();
        }

        return this;
    }

    async autoPopulateUpsertFields(){
        const connectionId = this.model.get('connectionId');
        if (!connectionId) return;

        const currentModel = this.model.get('currentActionDetails');
        if (!currentModel) return;

        // Only auto-populate if the CURRENT Send has just the instanceId placeholder
        // (user just switched to UPSERT or opened an UPSERT that only has instanceId)
        const getParams = (model) => {
            const p = model?.ActionXML?.Action?.Send?.Parameter;
            return Array.isArray(p) ? p : (p ? [p] : []);
        };
        const currentParams = getParams(currentModel);

        const isPlaceholder = (params) => params.length === 1 && params[0]._name === 'instanceId';
        if (!isPlaceholder(currentParams)) return;

        try {
            const linkedApps = await getLinkedApps(connectionId);
            if (!Array.isArray(linkedApps) || linkedApps.length === 0) {
                console.warn('No linked app for this connection; cannot auto-populate UPSERT fields');
                return;
            }

            const app = linkedApps[0];
            RestService.getFormFields(app.formId, app.formGUID || '', (err, fields) => {
                if (err) {
                    console.error('Failed to load form fields:', err);
                    return;
                }
                const fieldArray = Array.isArray(fields) ? fields : (fields ? [fields] : []);
                const fieldNames = fieldArray
                    .map(f => f['@name'] || f['@Name'] || f._name)
                    .filter(Boolean);

                if (fieldNames.length === 0) return;

                // Build Send Parameters: instanceId (fixed) + all linked app fields
                const newParams = [
                    {
                        _id: sequenceService.nextDomId(),
                        _name: 'instanceId',
                        _operation: '0',
                        _value: 'instanceId',
                        _isFixed: 'false',
                        _fixedValue: ''
                    },
                    ...fieldNames.map(name => ({
                        _id: sequenceService.nextDomId(),
                        _name: name,
                        _operation: '0',
                        _value: name,
                        _isFixed: 'false',
                        _fixedValue: ''
                    }))
                ];

                currentModel.ActionXML.Action.Send.Parameter = newParams;
                this.model.set('currentActionDetails', currentModel, { silent: true });

                // Also sync the "original" snapshot so this looks like the baseline
                // (user hasn't made actual changes — auto-populate is just loading defaults)
                const originalModel = this.model.get('actionDetails');
                if (originalModel && originalModel.ActionXML && originalModel.ActionXML.Action && originalModel.ActionXML.Action.Send) {
                    originalModel.ActionXML.Action.Send.Parameter = _.cloneDeep(newParams);
                    this.model.set('actionDetails', originalModel, { silent: true });
                }

                // Trigger re-render so the grid shows the populated fields
                // hasChanges stays false — user hasn't made real edits yet
                this.model.trigger('change');
            });
        } catch (err) {
            console.error('Failed to load linked apps:', err);
        }
    }

    remove(){
        $(window).unbind('resize');
        super.remove();
    }
}

export default ActionVectorDB;
